import { Badge, Tooltip } from '@mantine/core';

import { StatusDotView } from '../../../common/atoms/StatusDot';
import type { CardBadgeTone, CardBadgeViewProps } from './CardBadge.types';

const TONE_COLOR: Record<CardBadgeTone, string> = {
  attention: 'orange',
  neutral: 'gray',
  positive: 'teal',
  negative: 'red',
  info: 'blue',
};

export function CardBadgeView({
  label,
  tone = 'neutral',
  color,
  dot = false,
  icon,
  size = 'sm',
  variant = 'light',
  uppercase = true,
  tooltip,
  radius = 'sm',
}: CardBadgeViewProps) {
  const resolvedColor = color ?? TONE_COLOR[tone];

  const leftSection = icon ?? (dot ? <StatusDotView color={resolvedColor} size={6} /> : undefined);

  const badge = (
    <Badge
      size={size}
      variant={variant}
      color={resolvedColor}
      radius={radius}
      style={uppercase ? undefined : { textTransform: 'none' }}
      leftSection={leftSection}
    >
      {label}
    </Badge>
  );

  return tooltip ? <Tooltip label={tooltip}>{badge}</Tooltip> : badge;
}
